import React, { useEffect, useState } from "react";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import { MdClose } from "react-icons/md";
import tw from "tailwind-styled-components";
import axios from "axios";
import Config from "../../Config";
import { useSelector } from "react-redux";
import { ActionSection, InputGroup, Label, ScrollableContent, SideCancelBtn, SubmitBtn, Wrapper } from "../Styles/InputStyles";
import { toast } from "react-toastify";
import { useMutation } from "react-query";

const AddNoteModal = ({ isOpen, onClose, tenantId, onNoteAdded, setIsAddNoteModalOpen }) => {
    const [height, setHeight] = useState(window.innerHeight);
    const user = useSelector((state) => state.UserReducer.user);

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight);
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const initialValues = {
        remark: "",
    };

    const validationSchema = Yup.object().shape({
        remark: Yup.string()
            .min(4, "Note must be at least 4 characters long")
            .max(500, "Note must not exceed 500 characters")
            .required("Note is required"),
    });

    //------- Add Note -------
    const addNotesFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/tenant/add/note`, values, {
            headers: {
                authorization: "Bearer" + " " + user.token,
                "Content-Type": "application/json",
            },
        });
    };

    const onAddNoteSuccess = (data) => {
        if (data?.data?.isSuccess === true) {
            toast.success(data?.data?.msg || "Success");
            setIsAddNoteModalOpen(false);
            onNoteAdded();
        } else {
            toast.error(data?.data?.msg || "An Error Occured");
        }
    };

    const onAddNoteError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: addNoteLoading, mutate: addNoteMutate } = useMutation(
        addNotesFunction,
        {
            onSuccess: onAddNoteSuccess,
            onError: onAddNoteError,
        }
    );

    const handleSubmit = (values) => {
        addNoteMutate({
            tenantId: tenantId,
            note: values.remark,
        });

    };

    if (!isOpen) return null;

    return (
        <Overlay>
            <ModalWrapper>
                <Container style={{ height: `${height}px`, overflow: 'auto', WebkitOverflowScrolling: 'touch' }}>
                    <Header>
                        <h1 className="text-white text-lg font-medium">Add Note</h1>
                        <button onClick={onClose}>
                            <MdClose color="white" size={24} />
                        </button>
                    </Header>

                    <div className="px-6 h-full flex flex-col justify-between">
                        <Formik
                            initialValues={initialValues}
                            onSubmit={handleSubmit}
                            validationSchema={validationSchema}
                        >
                            {({ errors, touched, isSubmitting }) => (
                                <Form>
                                    <ScrollableContent className="max-h-[calc(100dvh-140px)]">
                                        <Wrapper>
                                            <InputGroup>
                                                <Label
                                                >
                                                    Note *
                                                </Label>
                                                <Field
                                                    as="textarea"
                                                    name="remark"
                                                    id="remark"
                                                    rows="6"
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg outline-none resize-none"
                                                    placeholder="Enter your note here..."
                                                />
                                                {errors.remark && touched.remark && (
                                                    <div className="text-red-500 text-xs mt-1">{errors.remark}</div>
                                                )}
                                            </InputGroup>
                                        </Wrapper>
                                    </ScrollableContent>
                                    <ActionSection>
                                        <SideCancelBtn type="button" onClick={onClose}>
                                            Cancel
                                        </SideCancelBtn>
                                        <SubmitBtn type="submit" disabled={addNoteLoading}>
                                            {addNoteLoading ? "Adding..." : "Add Note"}
                                        </SubmitBtn>
                                    </ActionSection>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </Container>
            </ModalWrapper>
        </Overlay>
    );
};

// Styled Components
const Overlay = tw.div`fixed inset-0 z-50 flex items-center justify-end bg-black/50`
const ModalWrapper = tw.div`bg-white w-11/12 h-full flex flex-col relative`
const Container = tw.div`bg-white w-full overflow-hidden flex flex-col`;
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`;

export default AddNoteModal;